import { useNavigate } from 'react-router-dom';
import { FileUp } from 'lucide-react';

import { ProcessPickerDialog } from '@/components/processos/ProcessPickerDialog';

import type { PeticaoModelo } from './ModelosPage';
import { urlDoProtocolo } from '@/pages/processos/autos/protocolo/entradaDoProtocolo';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  modelo: PeticaoModelo | null;
}

/**
 * Diálogo "Usar modelo": atalho direto a partir da lista de modelos para o
 * peticionamento com o modelo já pré-aplicado.
 *
 * Como o peticionamento é por-processo e o modelo resolve suas variáveis com
 * base no processo (partes, número, etc.), o processo precisa ser escolhido
 * antes. Reusa o `ProcessPickerDialog`; ao confirmar, abre os autos do processo
 * com o editor (PLANO_BANCADA, Bloco 4) e o modelo aplicado nele — o texto que o
 * editor tinha fica em Versões.
 */
export function ModeloUsarDialog({ open, onOpenChange, modelo }: Props) {
  const navigate = useNavigate();

  return (
    <ProcessPickerDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Usar modelo"
      description="Escolha o processo — o modelo será aplicado no corpo da petição, com as variáveis já preenchidas a partir do processo."
      confirmLabel="Continuar"
      confirmIcon={FileUp}
      onConfirm={(numero) => {
        if (!modelo) return;
        navigate(urlDoProtocolo(numero, { modelo: modelo.id }));
      }}
    />
  );
}
